import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux"; // assuming you store user in Redux

const AuthRoute = () => {
  const { userInfo } = useSelector((state) => state.userLogin || {}); // adapt to your slice name

  // Check if user is logged in
  const isAuthenticated = !!userInfo;

  return isAuthenticated ? <Outlet /> : <Navigate to="/admin" replace />;
};

export default AuthRoute;
